// extracted by mini-css-extract-plugin
export default {"wrapper":"branding-error-modal_wrapper__FTf6+","button":"branding-error-modal_button__tJnMT","opacity-transition":"branding-error-modal_opacity-transition__7YeAO"};